import gql from 'graphql-tag';

export const queryForMOCEventCategories = gql`
  query queryForMOCEventCategories(
    $limit: Int
    $page: Int
    $query: MOCEventCatSortOrQuery
    $sort: MOCEventCatSortOrQuery
  ) {
    queryForMOCEventCategories(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        createdAt
        createdBy
        deletedAt
        enabled
        id
        updatedAt
        name
        updater
        version
        businessUnitString
        businessUnits {
          name
        }
      }
      totalRecords
    }
  }
`;
